import { Routes, Route, HashRouter } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import MainLayout from "./layouts/MainLayout";
import FAQs from "./pages/FAQs";
import Commercial from "./pages/Commercial";
import WhatIsComposting from "./pages/WhatIsComposting";
import DropOffLocations from "./pages/DropOffLocations";
import ContactUsPage from "./pages/ContactUs";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CompostOrderSuccess from "./pages/CompostOrderSuccess";
import CompostOrderPage from "./pages/CompostOrder";
import SignUpForm from "./pages/SignUp";
import DropOffSignUpForm from "./components/DropOffSignUp";
import CurbsideSignUpForm from "./components/CurbsideSignUp";
import { initializePageTracking } from "./utils/pageTracking";

export type AppProps = {
  /**
   * Whether to include the Router component. Set to false when testing with MemoryRouter.
   */
  includeRouter?: boolean;
};

const AppContent = () => (

  <MainLayout>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="faqs" element={<FAQs />} />
      <Route path="commercial" element={<Commercial />} />
      <Route path ="what-is-composting" element={<WhatIsComposting />}/>
      <Route path="drop-off-locations" element={<DropOffLocations />} />
      <Route path="contact-us" element={<ContactUsPage />} />
      <Route path="checkout-success" element={<CheckoutSuccess />} />
      <Route path="compost-order-success" element={<CompostOrderSuccess />} />
      {/* <Route path="orderCompost" element={<CompostOrderPage />} /> */}
      <Route path="signUp" element={<SignUpForm />} />
      <Route path="dropOff" element={<DropOffSignUpForm />} />
      <Route path="curbside" element={<CurbsideSignUpForm />} />
      {/* Add other routes here */}
    </Routes>
  </MainLayout>

);

const App = ({ includeRouter = true }: AppProps) => {
  useEffect(() => {
    // Initialize page tracking when the app starts
    initializePageTracking();
  }, []);

  if (!includeRouter) {
    return <AppContent />;
  }

  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
};

export default App;
